<template>
    <router-link :to="to" :class="buttonType">
        <img v-if="buttonType === `blue-button`" src="@/assets/img/icons/white-drop.svg" :alt="alt"/>
        <img v-if="buttonType === `grey-button`" src="@/assets/img/icons/water-print-icon.svg" :alt="alt"/>
        <img v-if="buttonType === `white-button`" src="@/assets/img/link_img/faturaniyukleel.png" :alt="alt"/>
        <p>{{ text }}</p>
    </router-link>
</template>

<script>

    export default {
        name: "ButtonBlueBackground",
        props: ['to', 'text', 'alt', 'buttonClass'],
        computed: {
            buttonType() {
                return this.buttonClass ? this.buttonClass : 'blue-button';
            }
        }
    }
</script>

<style lang="scss">
    .story-button-container {
        margin-top: auto;
        width: 100%;
        height: 56px;

        .next-story {
            width: 100%;
            text-align: center;
            margin-bottom: 15px;
            font-size: 14px;
            font-weight: bold;
        }

        .blue-button,
        .grey-button,
        .white-button {
            display: flex;
            justify-content: space-around;
            align-items: center;
            min-width: 100px;
            max-height: 57px;
            min-height: 57px;
            border-radius: 150px;
            text-decoration: none;
            color: white;
            padding: 5px 0;
            font-size: 14px;
            font-weight: bolder;

            &.home-start-story {
                width: 208px !important;
                min-width: 208px !important;
                img {
                    width: auto;
                    object-fit: contain;
                    height: 28px;
                    @media only screen and (max-device-width: 768px) {
                        height: 60px;
                    }
                }
            }

            &.water-print {
                width: 252px !important;
                min-width: 252px !important;
                img {
                    width: auto;
                    height: 40px;
                    object-fit: contain;
                    @media only screen and (max-device-width: 768px) {
                        height: 80px;
                    }
                }
            }

            img {
                margin-left: 20px;
                margin-right: 14px;
            }

            p {
                text-transform: uppercase;
                margin-right: 20px;
            }
        }

        .blue-button {
            background: linear-gradient(0deg, #00a0e2, #00c3ee);
        }

        .grey-button {
            background: linear-gradient(0deg, #4a4a4a, #9b9b9b);
        }
    }
</style>
